// removed by extract-text-webpack-plugin
module.exports = {"speedSlider":"speedSlider","speedSlider_row":"speedSlider_row","speedSlider_cell":"speedSlider_cell","volumeBlock":"volumeBlock","volumeProgressBar":"volumeProgressBar","noselect":"noselect"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/SpeedSlider/style.scss
// module id = 680
// module chunks = 0